(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("webinarLearnerAccess", {
        templateUrl: "app/account/learnerAccess/learningItemType/webinarLearnerAccess.component.html",
        require: {
            parentCtrl: "^^learningItemLearnerAccessModal"
        },
        controller: ["assignmentLearnerAccessWebinarResource", "$state", "messageService", "$uibModal", "frameworkService", "_", WebinarLearnerAccessCtrl],
        controllerAs: "vm"
    });
    function WebinarLearnerAccessCtrl(assignmentLearnerAccessWebinarResource, $state, messageService, $uibModal, frameworkService, _) {
        var vm = this;
        vm.number = $state.params.number;
        vm.version = $state.params.version;
        vm.code = $state.params.code;
        vm.singleLanguageSite = frameworkService.data.tenant.enabledLocalizations.length === 1;
        this.$onInit = function () {
            vm.assignment = vm.parentCtrl.assignment;
            vm.assignmentCompletedOrExpired = vm.assignment.assignmentStatus === 4 || vm.assignment.assignmentStatus === 3;
            vm.parentCtrl.requalifyClicked = false;
            load();
        };
        /////////////////////////////////////////////////////////////////////////////////////
        function load() {
            assignmentLearnerAccessWebinarResource.get({ id: vm.assignment.id }, function (result) {
                vm.parentCtrl.buttons = [];
                vm.parentCtrl.haveMultipleButtons = true;
                vm.model = result;
                //expired or expiring
                if (vm.assignment.assignmentStatus === 4 || vm.assignment.expiring)
                    setupRequalifyButton();
                //activated or assigned
                if (vm.assignment.assignmentStatus === 1 || vm.assignment.assignmentStatus === 2) {
                    if (vm.model.webinarType === 1) //live webinar, select webinar
                        setupSelectWebinarButton();
                    if (vm.model.recordings.length > 0)
                        setupViewRecordingsButton();
                }
                //completed and there are recordings, add the view recordings button
                if (vm.assignment.assignmentStatus === 3 && vm.model.recordings.length > 0)
                    setupViewRecordingsButton();
                //if Disabled or Completed, learners wont be able to select a new webinar nor re-qualify
                vm.loading = false;
                vm.parentCtrl.contentLoaded = true;
            }, function (error) {
                messageService.error(error);
            });
        }
        var setupRequalifyButton = function () {
            vm.parentCtrl.buttons.push("requalifyButton");
            vm.parentCtrl.requalify = vm.requalify;
        };
        var setupSelectWebinarButton = function () {
            if (vm.model.webinars.length === 0) {
                vm.parentCtrl.buttons.push("selectWebinarButton");
                vm.parentCtrl.selectWebinar = vm.selectWebinar;
            }
        };
        var setupViewRecordingsButton = function () {
            vm.parentCtrl.buttons.push("viewRecordingsButton");
            vm.parentCtrl.viewRecordings = vm.viewRecordings;
        };
        vm.selectWebinar = function () {
            $state.go("main.selectWebinar", { number: vm.number, version: vm.version, code: vm.code });
        };
        vm.requalify = function () {
            vm.parentCtrl.requalifyClicked = true;
            vm.assignment.$requalify({ number: vm.number, version: vm.version, code: vm.code }, function () {
                $state.reload();
                //$state.go("main.learningPath.learningItemModal", { number: vm.number, version: vm.version, code: vm.code });
            }, function (error) {
                messageService.error(error);
            });
        };
        vm.withdraw = function (webinar) {
            $uibModal.open({
                templateUrl: "withdrawWebinarConfirmation.html",
                windowClass: "confirmation-modal",
                controller: ["data", "$scope", function (data, $scope) {
                        var vm = this;
                        vm.withdraw = function () {
                            data.disableButton = true;
                            assignmentLearnerAccessWebinarResource.withdrawFromWebinar({ activationId: data.webinar.id }, function () {
                                data.model.webinars = _.reject(data.model.webinars, data.webinar);
                                setupSelectWebinarButton();
                                messageService.success("learningItem.learnerAccess.webinar.withdraw.success");
                                $scope.$close();
                            }, function (error) {
                                messageService.error(error);
                                data.disableButton = false;
                            });
                        };
                    }],
                controllerAs: "vm",
                resolve: {
                    data: {
                        webinar: webinar,
                        model: vm.model,
                        code: vm.code,
                        disableButton: vm.disableButton
                    }
                }
            }).result.catch(angular.noop);
        };
        vm.completeRecorderdWebinar = function (callBack) {
            if (vm.model.webinarType === 2 && (vm.assignment.assignmentStatus === 1 || vm.assignment.assignmentStatus === 2)) {
                vm.assignment.$complete({ number: vm.number, version: vm.version, code: vm.code }, function () {
                    callBack();
                }, function (error) {
                    messageService.error(error);
                });
            }
        };
        vm.viewRecordings = function () {
            $uibModal.open({
                templateUrl: "viewRecordings.html",
                controller: ["data", "$scope", "parent", function (data, $scope, parent) {
                        var vm = this;
                        vm.singleLanguageSite = frameworkService.data.tenant.enabledLocalizations.length === 1;
                        vm.model = data.model;
                        vm.view = function () {
                            parent.completeRecorderdWebinar(function () {
                                $scope.$close();
                                parent.parentCtrl.dismiss();
                            });
                        };
                    }],
                controllerAs: "vm",
                resolve: {
                    data: {
                        model: vm.model
                    },
                    parent: vm
                }
            }).result.catch(angular.noop);
        };
    }
}());
